import React from 'react';
import {
  MDBBtn, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader,MDBInputGroup,
  MDBModalTitle, MDBModalBody, MDBModalFooter, MDBRadio, MDBIcon
} from 'mdb-react-ui-kit';

const CustomModal = ({dItem, deleteItem, openModal=true}) => {
    const [selectedItem, setSelectedItem] = React.useState(dItem);
    const [sku, setSelectedSku] = React.useState(dItem.variants ? dItem.variants[0] : {});
    const [quantity, setQuantity] = React.useState(1);
    const [cart, setCart] = React.useState(JSON.parse(localStorage.getItem("cart"))??[]);

    const confirmAddToCart=()=>{
        const newCart = cart;
        const newItem = {};
        newItem.sku = sku;
        newItem.id = selectedItem.id;
        newItem.name = selectedItem.name;
        newItem.quantity = quantity;
        newCart.push(newItem);
        localStorage.setItem("cart", JSON.stringify(newCart));
        setCart(newCart);
        window.location.reload();
    }

    const deleteFromCart=()=>{
        const newCart = cart.filter(c=>c.id!==dItem.id)
        localStorage.setItem("cart", JSON.stringify(newCart));
        let path = window.location.pathname;
        if(newCart.length===0){
            path = "/";
        }
        window.location.href = path;
    }
    
    const closeModal=()=>{
        setSelectedItem({});
        window.location.reload();
    }

    const selectedSku=(e)=>{
        const sku = e.target.value;
        const skuDet = selectedItem.variants.filter(v=>v.sku===sku);
        const dSku = skuDet[0];
        if(quantity>dSku.quantity)setQuantity(dSku.quantity);

        setSelectedSku(dSku);
    }

    const getOptions = (v)=>{
        let options = v.color;
        if(v.size){
            options += `-${v.size}`;
        }
        return options ?? "One fit";
    }

    const increaseQty=()=>{
        let newQuantity = quantity;
        if(sku.quantity>quantity)newQuantity++;
        setQuantity(newQuantity);
    }

    const decreaseQty=()=>{
        let newQuantity = quantity;
        if(newQuantity>1)newQuantity--;
        setQuantity(newQuantity);
    }

    if (openModal) {
        return (
        <MDBModal open={openModal} onClose={closeModal} tabIndex='-1'>
            <MDBModalDialog>
                <MDBModalContent style={{color: "#333"}} >
                    <MDBModalHeader>
                        <MDBModalTitle>{selectedItem.name}
                            <br /><span style={{fontSize:9}}>{selectedItem.description}</span>
                        </MDBModalTitle>
                        {!deleteItem&&<p style={{color: "red"}}>${selectedItem.variants[0].price}</p>}
                    </MDBModalHeader>
                    {!deleteItem&&<MDBModalBody>
                        {selectedItem.variants.map(v=>(
                            <MDBRadio key={v.sku} name='inlineRadio' defaultChecked={sku.sku===v.sku} value={v.sku} label={getOptions(v)} inline onChange={selectedSku} />
                        ))}
                        <br />Quantity:<br />
                        <MDBInputGroup noBorder className='mb-3' textBefore={
                            <MDBBtn style={{ backgroundColor: '#c61118' }} onClick={decreaseQty}>
                                <MDBIcon fas icon='minus'/>
                            </MDBBtn>
                        } textAfter={
                            <MDBBtn style={{ backgroundColor: '#25d366' }} onClick={increaseQty}>
                                <MDBIcon fab icon='add'/>
                            </MDBBtn>
                        }>
                            <input className='form-control' type='text' value={quantity} disabled />
                        </MDBInputGroup>
                    </MDBModalBody>}
                    {deleteItem ?
                    <MDBModalFooter>
                        <MDBBtn color='dark' onClick={deleteFromCart}>Delete From Cart</MDBBtn>
                    </MDBModalFooter> :
                    <MDBModalFooter>
                        <MDBBtn color='dark' onClick={confirmAddToCart}>Add to Cart</MDBBtn>
                    </MDBModalFooter>}
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>)
    }
}

export default CustomModal;
